import {TemplateType} from "@generated"
import {StateLabel} from "@platform/models/state-labels/state-label"

export const ProductTypeLabels: Map<TemplateType, StateLabel<TemplateType>> = new Map<TemplateType, StateLabel<TemplateType>>([
    [TemplateType.Product, {state: TemplateType.Product, label: "Product", background: "#989898"}],
    [TemplateType.Part, {state: TemplateType.Part, label: "Part", background: "#7cbcb0"}],
])
